import { ApolloError } from '@apollo/client';

import { useMagicLinkLogoutMutation as useApolloMagicLinkLogoutMutation } from '@occc/graphql';

export const useMagicLinkLogoutMutation = (
  onError?: (error: ApolloError) => void,
  onCompleted?: (result: boolean) => void,
) => {
  const [logout] = useApolloMagicLinkLogoutMutation({
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
    onCompleted: (data) => {
      if (onCompleted) {
        onCompleted(data.magicLinkLogout);
      }
    },
  });

  return logout;
};
